/*
@param includeUrl {string} for email attachment templates, loads attachment from specified url (as HTML) based on template dropdown selection
@param attachmentsNumber {number=} have been created so you can watch the changes easily (whether the file have been uploaded or removed) - specifically for Candidate > Attachment Section (Compliance Doc and Skills) > Certify checkbox
@param totalSize {number} total size of all attachments (in MB)
@param filesDeleted {Object=} stores the existing files data (id, name, deleted - true or empty), so you can send them with your ajax call
*/
(function() {


    var fileUpload = function($timeout, $templateCache) {
        return {
            restrict: "EA",
            scope: {
                //reminder [ '@':'one-way binding', '=':'two-way binding', '=?':'two-way binding optional', '&':'literal binding' ]
                label: '@',
                fieldName: '@',
                allowedExtensions: "@",
                filesObjects: "=?",
                filesDeleted: "=?", // for ajax call
                attachmentsNumber: "=?",
                maxSize: "@",
                maxTotalSize: "@",
                maxFiles: "&",
                required: "=",
                readonly: "=",
                validationMessages:'&',
                includeUrl: "&?",
                tooltip: '@',
                attachmentLinkParams: '@'
            },
            template: function(tElement, tAttrs){
                return [
                    '<div class="xmsUiAttachmentNew clearfix" style="margin-top:0.5em;">',
                        '<label ng-if="label" style="display:block;" for="attachments" class="control-label" ' +
                        'ng-class="{required:required}" style="margin-bottom:5px;">{{::label}}  <span ng-if="tooltip" xms-tooltip="{{::tooltip}}"></span></label>',
                        tElement.html(),
                        $templateCache.get("formWidget/fileUpload.html"),
                    '</div>'].join('');
            },
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

                this.$onInit = function(){
                    if(!angular.isDefined($scope.filesObjects)){
                        $scope.filesObjects = {};
                    }

                    $scope.files = {
                        upload:[],
                        uploadNgRepeat:[null],
                        attached: [],
                        $fileObject:{},
                        filesDeletedData:[]
                    };
                    $scope.model = { // dotFix (model.)
                        savedAttachmentsNum :0,
                        newAttachmentsNum: 0
                    };
                    $scope.widget = {};
                    if( angular.isDefined($scope.maxTotalSize) && $scope.maxTotalSize!=='') {
                        $scope.widget.maxTotalSize = $scope.maxTotalSize * 1024 * 1024; // total max size in MB, translated to bytes
                    }
                }


                $timeout(function(){
                    $scope.singleUpload = (angular.isDefined($scope.maxFiles()) && $scope.maxFiles() === 1);
                    $scope.validationMsg = {
                        maxsize: 'The file is too big.',
                        extension: 'Invalid extension.',
                        required: $scope.singleUpload ? 'The file is required.' : 'At least one file is required.'
                    };
                    // if validationMesssages exists they should overwrite validationMsg
                    angular.merge( $scope.validationMsg, $scope.validationMessages() );


                    $scope.$watch('includeUrl()',function(newVal, oldVal){
                        if(newVal !== oldVal){
                            // load new template
                            $scope.widget.includeLoading = true;
                            $scope.model.savedAttachmentsNum = 0;

                            delete $scope.files.fileDeleted;
                            delete $scope.files.fileStatus;
                        }
                    });

                    $scope.attachmentLengthExcludingUndefined = function() {
                        return $scope.files.upload.filter(function(f) {
                           return f.path
                        }).length
                    }

                });
            }],
            replace: true,
            transclude: false,
            link: function(scope, element, attrs) {

                scope.maxSizeText = bytesToSize(scope.maxSize, false);

                scope.removeAttachment = function(idx) {
                    if (scope.singleUpload) {
                        scope.files.upload = []
                        scope.files.attached = []
                    } else {
                        scope.files.upload[idx] = undefined
                        scope.files.attached[idx] = undefined
                    }
                    scope.model.newAttachmentsNum = scope.model.newAttachmentsNum - 1
                }

                $timeout(function(){

                    //Bizarre
                    scope.$watch(
                        function(){
                            return uploadCopyWithoutScope(scope.files.upload);
                        },
                        //Watches for new files being attached
                        function(uploadCopyWithoutScopeNew, oldVal){
                            if(uploadCopyWithoutScopeNew !== oldVal){
                                if(!scope.singleUpload){
                                    renderNewFiles(uploadCopyWithoutScopeNew);
                                    countSizeOfAttachments();
                                    appendNewFiles();
                                } else {
                                    // If bug is found where multi-attachments is used, the code is safe.
                                    // However to minimise disruption, currently only doing for singular uploads.
                                    deletePreExistingFile();
                                    replaceWithNewFile();
                                }

                                //Need this as the existing counting way doesn't work after first upload
                                countNumberOfNewAttachments();
                            }
                        },
                        true
                    );

                    scope.$watch('model.savedAttachmentsNum', function(newVal, oldVal){
                        scope.attachmentsNumber = scope.model.newAttachmentsNum + scope.model.savedAttachmentsNum;
                    });

                    scope.$watch('model.newAttachmentsNum', function(newVal, oldVal){
                        scope.attachmentsNumber = scope.model.newAttachmentsNum + scope.model.savedAttachmentsNum;
                    });

                    if( attrs.filesDeleted!=='' ){
                        scope.$watch('files.filesDeletedData', function(newVal, oldVal){
                            scope.filesDeleted = scope.files.filesDeletedData;
                        });
                    }

                });

                // Used in template as ng-repeat="file in files.uploadNgRepeat track by $index"
                function renderNewFiles(uploadCopyWithoutScopeNew){
                    scope.files.uploadNgRepeat = uploadCopyWithoutScopeNew;
                    scope.files.uploadNgRepeat.unshift(null);
                }

                function countSizeOfAttachments(){
                    // max total attachment size validation
                    if( angular.isDefined(scope.maxTotalSize) && scope.maxTotalSize!=='') {
                        scope.model.newAttachmentsSize = 0;
                        angular.forEach(scope.files.upload, function(f){
                            if(angular.isDefined(f) && f!==null){
                                scope.model.newAttachmentsSize += f.sizeBytes;
                            }
                        });
                    }
                }

              function countNumberOfNewAttachments(){
                  // max total new attachment number
                  scope.model.newAttachmentsNum = 0;
                  angular.forEach(scope.files.upload, function(f){
                      if(angular.isDefined(f) && f!==null){
                          scope.model.newAttachmentsNum += 1;
                      }
                  });
              }

                // Retain all the pre-existing files (including any removal requests) and append any new attached files
                function appendNewFiles(){
                    scope.filesObjects = [];
                    // Retain all the pre-existing files (including any removal requests)
                    scope.files.filesDeletedData.forEach( function(obj, idx){
                        scope.filesObjects.push(obj);
                    });
                    // Append new any new attached files
                    scope.filesObjects.push(scope.files.$fileObject);
                }

                // erase the pre-existing singular file with new singular attached file
                function replaceWithNewFile(){
                    scope.filesObjects = scope.files.$fileObject;
                }

                // When a new file is attached, remove the deleted state. Otherwise the new file will be considered deleted
                function deletePreExistingFile(){
                    // Loop through each uploaded file
                    scope.files.upload.forEach( function(obj, idx){
                        // Remove for the correct index, the file status String
                        if(scope.files.fileStatus && scope.files.fileStatus[idx])
                            delete scope.files.fileStatus[idx];
                        // Remove for the correct index, the file deleted Boolean
                        if(scope.files.fileDeleted && scope.files.fileDeleted[idx])
                            delete scope.files.fileDeleted[idx];
                    });
                }

                // ------------------- Drag and drop functionality ------------------------------
                element.bind('dragover', processDragOverOrEnter);
                element.bind('dragenter', processDragOverOrEnter);
                element.bind('dragend', endDragOver);
                element.bind('dragleave', endDragOver);
                element.bind('drop', dropHandler);

                function getEvent(angularEvent) {
                    return angularEvent.originalEvent || angularEvent;
                }
                function dropHandler(angularEvent) {
                    var event = getEvent(angularEvent)
                    var file = event.dataTransfer.files;
                    var fileInput = angular.element(element[0].querySelectorAll('input[type=file]'))

                    event.preventDefault();

                    var list = new DataTransfer();
                    list.items.add(file[0]);
                    fileInput[fileInput.length -1].files = list.files

                    // Triggers the watcher
                    scope.singleUpload
                        ? scope.files.attached[0] = " "
                        : scope.files.attached.push(" ")

                    endDragOver();

                }
                function processDragOverOrEnter(angularEvent) {
                    var event = getEvent(angularEvent)
                    if (event) {
                        event.preventDefault();
                        event.dataTransfer.effectAllowed = 'copy';
                    }
                    element.addClass('dragging');
                    return false;
                }
                function endDragOver() {
                    element.removeClass('dragging');
                }

                // it used to be scope.files.upload, but it contains ngModel within
                // and Angular 1.7 makes not possible to copying the objects containing the scope,
                // (it fails with https://code.angularjs.org/1.7.8/docs/error/ng/cpws error)
                // so replaced with copyObj now which contains scope.files.upload without ngModel
                function uploadCopyWithoutScope(uploadObj){
                    var copyObj = [];
                    angular.forEach(uploadObj, function(obj, index){
                        if(angular.isDefined(obj)){
                            copyObj.push({
                                path: obj.path,
                                name: obj.name,
                                size: obj.size,
                                status: obj.status
                            });
                        } else {
                            copyObj.push(undefined);
                        }
                        // delete obj.ngModel;
                    });
                    return copyObj;
                }

            },
        };
    }
    fileUpload.$inject = ['$timeout','$templateCache'];
    angular.module('app').directive('fileUpload', fileUpload);
}());
